import { Component, OnInit } from '@angular/core';
import CryptoJS from 'crypto-js';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {ApiService} from '../services/api/api.service';
import {Router, ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import { SesionService } from 'src/app/services/sesion/sesion.service';
import { ToolsService } from '../services/tools/tools.service';

interface Company {
  id?: number | string;
  rif: string;
  nombre_empresa: string;
  mail: string;
  telefono?: string;
  direccion?: string;
  contacto?: string;
  telefono_contacto?: string;
  estado?: number;
}

interface CurrencyItem {
  codigo: string;
  description: string;
  iso: string;
  factor: number;
  estado: boolean | null;
}

interface CurrencySelected {
  moneyCod: string;
  estado: number;
}

interface User {
  id?: number | string;
  rol?: number;
}

interface CompanyResponse {
  code: number;
  company: Company[];
  currencies?: CurrencySelected[];
}

interface CurrencyInfoItem {
  codigo: string;
  descripcion: string;
  iso: string;
  factor: number;
}

interface CurrenciesResponse {
  code: number;
  info: {
    currency: CurrencyInfoItem[];
  };
}

interface CompanyFormValues {
  typeRif: string;
  rif: string;
  name: string;
  email: string;
  phone: string;
  direction: string;
  password: string;
  confirmPassword: string;
  name_contact: string;
  phone_contact: string;
  estado: number;
}

interface CompanyCreatePayload {
  rif: string;
  nombre_empresa: string;
  mail: string;
  password?: string;
  telefono?: string;
  direccion?: string;
  contacto?: string;
  telefono_contacto?: string;
  estado?: number;
  currencies: CurrencyItem[];
}

@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html',
  styleUrls: ['./edit-company.component.scss']
})
export class EditCompanyComponent implements OnInit {
  form: FormGroup | null = null;
  company: Company | null = null;
  currenciesSelected: CurrencySelected[] = [];
  editMode = false;
  loading = false;
  currencies: CurrencyItem[] = [];
  edit = false;
  user: User | null = null;
  companyId: number | string | null = null;
  parentPhone: string = '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$';
  passwordPattern = '^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?]).{8,}$';
  reload: boolean = false;
  changePassword = false;
  showPassword = false;
  showConfirmPassword = false;

  constructor(
    public api: ApiService,
    public router: Router,
    public snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private sesion: SesionService,
    public tool: ToolsService
  ) { }

  static passwordsMatch(group: AbstractControl): ValidationErrors | null {
    const pwd = group.get('password');
    const confirm = group.get('confirmPassword');
    if (!pwd || !confirm || pwd.disabled || confirm.disabled) { return null; }
    return pwd.value === confirm.value ? null : { passwordMismatch: true };
  }

  ngOnInit(): void {
    this.user = this.sesion.getUser();
    console.log('::::', this.user);
    this.activatedRoute.params.subscribe((params: { id?: string }): void => {
      if (params.id !== 'new' && (params.id || this.user?.rol === 3)) {
        this.companyId = params.id || this.user?.id || null;
        console.log('::::::', this.companyId);
        this.editMode = true;
        this.loading = true;
        this.api.getOneCompany(this.companyId).subscribe((company: CompanyResponse): void => {
          this.loading = false;
          if (company.code === 200) {
            this.company = company.company[0];
            this.currenciesSelected = company.currencies || [];
            this.initilize();
            this.getCurrencies();
            console.log(this.company);
          }
        }, (err: any): void => {
          this.loading = false;
        });
      } else {
        this.getCurrencies();
        this.initilize();
      }
    });
  }

  public checkoutMoneySelect(): CurrencyItem[] {
    return this.currencies.filter((elem: CurrencyItem) => elem.estado === true );
  }

  private getCurrencies(): void {
    this.loading = true;
    this.api.getCurrencies().subscribe((currencies: CurrenciesResponse): void => {
      this.loading = false;
      if (currencies.code === 200) {
        const array: CurrencyItem[] = [];
        for (const item of currencies.info.currency) {
          let state: boolean | null = this.editMode ? null : false;
          if (this.editMode) {
            const found: CurrencySelected | undefined = this.currenciesSelected.find((elem: CurrencySelected): boolean => elem.moneyCod === item.codigo);
            if (found) {
              state = found.estado === 1 ? true : false;
            }
          }

          array.push({
            codigo: item.codigo,
            description: item.descripcion,
            iso: item.iso,
            factor: item.factor,
            estado: state
          });
        }
        this.currencies = array;
      }
    }, (err: any): void => {
      this.loading = false;
      console.log(err);
    });
  }

  private initilize(): void {
    this.form = new FormGroup({
      typeRif: new FormControl(this.editMode ? this.company?.rif?.[0] : 'J', [Validators.required]),
      rif: new FormControl(this.editMode ? this.company?.rif?.slice(1) : null, [Validators.required]),
      name: new FormControl(this.editMode ? this.company?.nombre_empresa : null, [Validators.required]),
      email: new FormControl(this.editMode ? this.company?.mail : null, [Validators.required, Validators.email]),
      phone: new FormControl(this.editMode ? this.company?.telefono : null, [
        Validators.required, Validators.pattern(this.parentPhone), Validators.maxLength(15)
      ]),
      direction: new FormControl(this.editMode ? this.company?.direccion : null, [Validators.required]),
      password: new FormControl(this.editMode ? 'xxxxxxxx' : null, [
        Validators.required, Validators.minLength(8), Validators.pattern(this.passwordPattern)
      ]),
      confirmPassword: new FormControl(this.editMode ? 'xxxxxxxx' : null, [Validators.required, Validators.minLength(8)]),
      name_contact: new FormControl(this.editMode ? this.company?.contacto : null, [Validators.required]),
      phone_contact: new FormControl(this.editMode ? this.company?.telefono_contacto : null, [
        Validators.required, Validators.pattern(this.parentPhone), Validators.maxLength(15)
      ]),
      estado: new FormControl(this.editMode ? this.company?.estado : 1)
    }, { validators: EditCompanyComponent.passwordsMatch });

    if (this.editMode) {
      this.enablesInputs(false);
    }
  }

  enablesInputs(value: boolean): void {
    if (!this.form) { return; }
    if (value) {
      if (this.user && this.user.rol !== 3) {
        this.form.get('typeRif')!.enable();
        this.form.get('rif')!.enable();
      }
      this.form.get('name')!.enable();
      this.form.get('email')!.enable();
      this.form.get('phone')!.enable();
      this.form.get('direction')!.enable();
      // this.form.get('password').enable();
      this.form.get('name_contact')!.enable();
      this.form.get('phone_contact')!.enable();
      this.form.get('estado')!.enable();
      this.edit = true;
    } else {
      this.form.get('typeRif')!.disable();
      this.form.get('rif')!.disable();
      this.form.get('name')!.disable();
      this.form.get('email')!.disable();
      this.form.get('phone')!.disable();
      this.form.get('direction')!.disable();
      this.changePassword = false;
      this.form.get('password')!.setValue('xxxxxxxx');
      this.form.get('password')!.disable();
      this.form.get('confirmPassword')!.setValue('xxxxxxxx');
      this.form.get('confirmPassword')!.disable();
      this.form.get('name_contact')!.disable();
      this.form.get('phone_contact')!.disable();
      this.form.get('estado')!.disable();
      this.edit = false;
    }
  }

  toggleChangePassword(checked: boolean): void {
    if (!this.form) { return; }
    if (checked) {
      this.form.get('password')!.setValue('');
      this.form.get('password')!.enable();
      this.form.get('confirmPassword')!.setValue('');
      this.form.get('confirmPassword')!.enable();
    } else {
      this.form.get('password')!.setValue('xxxxxxxx');
      this.form.get('password')!.disable();
      this.form.get('confirmPassword')!.setValue('xxxxxxxx');
      this.form.get('confirmPassword')!.disable();
    }
  }

  callSubmit(): void {
    if (this.edit) {
      this.onSubmit();
    }
  }

  onSubmit(): void {
    if (!this.form) { return; }
    const values: CompanyFormValues = this.form.value;
    this.loading = true;
    let id: number | string | null = null;

    if (this.editMode) {
      id = this.company?.id || this.user?.id || null;
    }

    this.api.createCompany({
      rif: this.company?.id ? this.company.rif : `${values.typeRif}${values.rif}`,
      nombre_empresa: String(values.name ?? ''),
      mail: String(values.email ?? ''),
      password: this.editMode && !this.changePassword
        ? undefined
        : CryptoJS.AES.encrypt(values.password, this.api.secret).toString(),
      telefono: String(values.phone ?? ''),
      direccion: String(values.direction ?? ''),
      contacto: String(values.name_contact ?? ''),
      telefono_contacto: String(values.phone_contact ?? ''),
      estado: values.estado ? 1 : 0,
      currencies: this.currencies
        .filter((c: CurrencyItem) => {
          const wasInCompany = this.currenciesSelected.some((sel: CurrencySelected) => sel.moneyCod === c.codigo);
          return wasInCompany || !!c.estado;
        })
        .map((c: CurrencyItem) => ({ ...c, estado: c.estado ? 1 : 0 }))
    }, id).subscribe((response: any): void => {
      this.loading = false;
      this.reload = true;
      if (response?.status === 'error') {
        this.snackBar.open(response?.message ? response?.message : 'Error inesperado creando empresa', 'ok', { duration: 5000 });
      } else if (response === 1002) {
        this.snackBar.open(`No se ${this.company?.id ? 'Actualizo' : 'Creo' } la empresa.`, 'ok', { duration: 5000 });
      } else {
        this.snackBar.open(`Se ${this.company?.id ? 'Actualizo' : 'Creo' } la empresa exitosamente.`, 'ok', { duration: 5000 });

        if (!this.company?.id) {
          this.router.navigate(['../companies'], {replaceUrl: true});
        } else {
          window.location.reload();
        }
      }
    }, (err: any): void => {
      this.loading = false;
      console.log(err);
      this.snackBar.open(err?.error?.message ? err?.error?.message : 'Error inesperado creando empresa', 'ok', { duration: 5000 });
    });
  }


}
